window.addEventListener('datalayer.view_item', (e) => {
    const product = JSON.parse(e.detail.product);

    window.dataLayer.push({
        productName: product.translation?.name,
        productPrice: product.price.value,
        productModel: product.model,
        productType: product.facet_type?.slug,
        productThumb: product.medium_normal?.path,
        productImage: product.medium_normal?.path,
    });
});
